/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { IconWidget } from '@weatherbug/react';

import { reduxConnect } from '../../../common';
import { degreeSymbol } from '../../common/utilities/symbols/degree';
import { CurrentConditionIconWrapper } from './styledComponents/currentConditionsIconWrapper';
import { CurrentConditionsObsContainer } from './styledComponents/currentConditionsObsContainer';
import { ObsTemperature, ObsTemperatureTextWrapper } from './styledComponents/obsTemperature';
import { IStdParameters, IStoreState } from '../../common/interfaces/types';

const defaultCurrentObsValue = '--';
const defaultIconCode = 999; // returns ? icon image

interface CurrentConditionsObsWrapperProps {
    authId: string;
    secret: string;
    stdParameters: IStdParameters;
    forecastIconResourceList: string;
    forecastIconSize: string;
    forecastIconSet: string;
    contentMgmtBaseUrl: string;
    iconCode: number;
    nowConditionsTemp: number;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { nowConditions } =  storeState;
    const { nowConditions: nowConditionsData } = nowConditions || {};
    const appState = storeState.appState.appState || {};
    const { authId, secret, stdParameters, forecastIconResourceList, forecastIconSize, forecastIconSet, contentMgmtBaseUrl } = appState || {};
    const { ic: iconCode, t: nowConditionsTemp } = nowConditionsData || {};

    return {
        nowConditionsTemp,
        authId,
        secret,
        stdParameters,
        forecastIconResourceList,
        forecastIconSize,
        forecastIconSet,
        contentMgmtBaseUrl,
        iconCode
    };
};

const mapDispatchToProps = {};

export const CurrentConditionsObsWrapper = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo(({   
    authId,
    secret,
    stdParameters,
    forecastIconResourceList,
    forecastIconSize,
    forecastIconSet,
    contentMgmtBaseUrl,
    iconCode=defaultIconCode,
    nowConditionsTemp }: CurrentConditionsObsWrapperProps) => {

    const displayCurrentConditionsTemp = Number.isFinite(nowConditionsTemp) ? `${nowConditionsTemp}${degreeSymbol}` : defaultCurrentObsValue;
    const isLongForecastReading = Number.isFinite(nowConditionsTemp) ? nowConditionsTemp.toString().length >= 3 : false;

    return (
        <CurrentConditionsObsContainer>
            <ObsTemperatureTextWrapper>
                <ObsTemperature isLongForecastReading={isLongForecastReading}>{displayCurrentConditionsTemp}</ObsTemperature>
            </ObsTemperatureTextWrapper>
            <CurrentConditionIconWrapper>
                <IconWidget iconCode={iconCode}
                    iconSet={forecastIconSet}
                    iconSize={forecastIconSize}
                    authId={authId}
                    secret={secret}
                    contentManagementBaseUrl={contentMgmtBaseUrl}
                    stdParameters={stdParameters}
                    resourceList={forecastIconResourceList}></IconWidget>
            </CurrentConditionIconWrapper>
        </CurrentConditionsObsContainer>
    );
}));

CurrentConditionsObsWrapper.displayName = 'CurrentConditionsBody';

